import React from 'react';

import {Icons, Sizes} from '@pb/kit-component-icon';
import {Message} from '@pb/kit-component-message';

export const ErrorMessage = ({message}: {message: string}) => (
    <Message iconProps={{type: Icons.ERROR, size: Sizes.Size_14}} color="error">
        {message}
    </Message>
);
